
import React from 'react';
import { Modal, Typography, Divider, Row, Col, Space, Button, Popconfirm, message } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Liability } from '../../types';

const { Title, Text } = Typography;

interface LiabilityDetailsProps {
  visible: boolean;
  onClose: () => void;
  liability: Liability | null;
  onEdit: (liability: Liability) => void;
  onDelete: (liabilityId: string) => void;
}

const LiabilityDetails: React.FC<LiabilityDetailsProps> = ({ visible, onClose, liability, onEdit, onDelete }) => {
  if (!liability) return null;

  const handleDelete = () => {
    onDelete(liability.uid);
  };

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={500}
      bodyStyle={{ padding: '24px', maxHeight: '80vh', overflowY: 'auto' }}
      style={{ top: 20, right: 20, position: 'fixed' }}
      closable
      mask={false}
      maskClosable
    >
      <Space direction="vertical" style={{ width: '100%' }}>
        {/* Header with Actions */}
        <Space style={{ width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
          <Title level={4}>Liability Details</Title>
          <Space>
            <Button
              type="primary"
              icon={<EditOutlined />}
              onClick={() => onEdit(liability)}
            >
              Edit
            </Button>
            <Popconfirm
              title="Are you sure you want to delete this liability?"
              onConfirm={handleDelete}
              okText="Yes"
              cancelText="No"
            >
              <Button type="primary" danger icon={<DeleteOutlined />}>
                Delete
              </Button>
            </Popconfirm>
          </Space>
        </Space>

        <Divider />

        {/* Liability Information */}
        <Title level={5}>Liability Information</Title>
        <Row gutter={16}>
          <Col span={12}>
            <Text strong>Associated Asset:</Text>
            <br />
            <Text>{liability.assetName}</Text>
          </Col>
          <Col span={12}>
            <Text strong>Description:</Text>
            <br />
            <Text>{liability.description}</Text>
          </Col>
        </Row>

        <Divider />

        {/* Liability Costs */}
        <Title level={5}>Liability Costs</Title>
        <Row gutter={16}>
          <Col span={12}>
            <Text strong>Monthly Payment:</Text>
            <br />
            <Text>${liability.amount.toLocaleString()}</Text>
          </Col>
          <Col span={12}>
            <Text strong>Source:</Text>
            <br />
            <Text>{liability.source}</Text>
          </Col>
        </Row>
      </Space>
    </Modal>
  );
};

export default LiabilityDetails;
